import React from 'react';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

const renderPaginationButtons = ({ totalPages, currentPage, handlePageChange }) => {
  const buttons = [];
  const delta = 2;

  // Previous button
  if (currentPage > 1) {
    buttons.push(
      <button
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        className="flex items-center justify-center w-10 h-10 mx-1 text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-700 transition-colors duration-200"
      >
        <IoChevronBack className="w-4 h-4" />
      </button>
    );
  }

  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 || 
      i === totalPages || 
      (i >= currentPage - delta && i <= currentPage + delta)
    ) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`w-10 h-10 mx-1 text-sm font-medium rounded-lg transition-colors duration-200 ${
            currentPage === i
              ? "bg-customOrange text-white shadow-md"
              : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:text-customOrange"
          }`}
        >
          {i}
        </button>
      );
    } else if (
      (i === currentPage - delta - 1 || i === currentPage + delta + 1) &&
      i > 1 &&
      i < totalPages
    ) {
      buttons.push(
        <span key={i} className="flex items-center justify-center w-10 h-10 mx-1 text-gray-400">
          ...
        </span>
      );
    }
  }

  // Next button
  if (currentPage < totalPages) {
    buttons.push(
      <button
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        className="flex items-center justify-center w-10 h-10 mx-1 text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-700 transition-colors duration-200"
      >
        <IoChevronForward className="w-4 h-4" />
      </button>
    );
  }

  return (
    <div className="flex items-center justify-center">
      {buttons}
    </div>
  );
};

export default renderPaginationButtons;